document.addEventListener('alpine:init', () => {

    const DEFAULT_LINK_DATA =
    {
        link_name: '',
        source: '',
        custom_source: false,
        has_link_name_error: false,
        has_source_error: false,
        link_name_error_text: '',
        source_error_text: '',
    };

    const SUBMIT_BUTTON_TEXT = 'Next: Add listening apps';
    const MAX_LINKS = 10;
    const MIN_LENGTH = 2;
    const MAX_LENGTH = 150;
    const MAX_SOURCE_LENGTH = 30;

    Alpine.data('prefix_tracking_links_new_x_data', () => ({
        // Logic for TomSelect Mixin
        ...tomSelectMixin(),
        // URL for loading episodes
        prefix_episode_load_url: null,
        prefix_latest_episode_url: null,
        // Function to initialize TomSelect
        prefix_episode_select: null,
        submit_button_text: SUBMIT_BUTTON_TEXT,
        submit_button_disabled: false,
        // Link types in show, episode
        link_type: '',
        link_type_error: false,
        no_episode_selected_error: false,
        // Array of additional episode links
        additional_links: [],
        // Array of sources, loaded from the server and also used to check for duplicates
        source_list: [],
        max_links: MAX_LINKS,
        // Unique index for each link set, starts from 0 and increments
        next_id: 0,

        init() {
            const url_data = this.$refs.url_data;
            this.prefix_episode_load_url = url_data.dataset.prefixEpisodeLoadUrl;
            this.prefix_latest_episode_url = url_data.dataset.prefixLatestEpisodeUrl;
            this.source_list = JSON.parse(url_data.dataset.sourceList);
            this.source_list.push('Other');
            this.initTomSelect();

            // Create default link data with the first source from the list
            const defaultLinkData = {
                ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                source: this.source_list[0] || '',
                id: this.next_id++,
            };

            this.additional_links.push(defaultLinkData);

            this.$watch('link_type', (new_value, old_value) => {
                // When the link_type changes from episode to show, ask the user to confirm
                // If they confirm, clear the episode additional links
                if (this.additional_links.length > 0 && this.additional_links[0].link_name !== '') {
                    let confirmation = confirm("Are you sure you want to change the link type? This will clear all existing links.");
                    if (confirmation) {
                        this.additional_links = [];
                        const newDefaultLinkData = {
                            ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                            source: this.source_list[0] || '',
                            id: this.next_id++,
                        };
                        this.additional_links.push(newDefaultLinkData);
                        this.prefix_episode_select.setValue('');
                    } else {
                        this.link_type = old_value;
                    }
                }

                // If the link_type changes to episode, clear the episode_id if present
                if (this.link_type === 'show') {
                    this.prefix_episode_select.setValue('');
                }
            });
        },

        add_link_set() {
            if (this.additional_links.length < this.max_links) {
                // Deep copy the default link data to avoid reference issues
                const newLinkData = {
                    ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                    source: this.source_list[0] || '',
                    id: this.next_id++,
                };
                this.additional_links.push(newLinkData);
            }
        },

        handle_custom_source(index) {
            if (this.additional_links[index].source === 'Other') {
                this.additional_links[index].source = '';
                this.additional_links[index].custom_source = true;
                this.additional_links[index].has_source_error = false;
                this.additional_links[index].source_error_text = '';
            }
        },

        remove_link_set(index) {
            if (this.additional_links.length > 1) {
                this.additional_links.splice(index, 1);
            }
        },

        handle_enter_key(event) {
            const tag = event.target.tagName.toLowerCase();
            const type = event.target.getAttribute('type');

            // Allow default behavior for textareas and buttons
            if (tag === 'textarea' || type === 'submit' || type === 'button') return;

            // Pressing Enter in a text input or select submits the form
            if (tag === 'input' || tag === 'select') {
                event.preventDefault();
                this.validate_links(event);
            }
        },
        validate_links(event) {
            const sources = new Set();
            const link_names = new Set();
            let has_error = false;
            let that = this;

            this.submit_button_disabled = true;
            this.submit_button_text = 'Submitting...';
            // Reset all error states
            this.link_type_error = false;
            this.no_episode_selected_error = false;
            this.additional_links.forEach((link) => {
                link.has_link_name_error = false;
                link.link_name_error_text = '';
                link.has_source_error = false;
                link.source_error_text = '';
            });

            if (this.link_type === '' || this.link_type === null) {
                has_error = true;
                that.link_type_error = true;
            }

            this.additional_links.forEach((link, i) => {
                const name = link.link_name.trim();
                const source = link.source.trim();

                if (!name) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Link name cannot be empty.';
                }

                // No duplicate link names
                if (link_names.has(name)) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Duplicate link name found.';
                }

                if (name.length > MAX_LENGTH) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = `Link name cannot exceed ${MAX_LENGTH} characters.`;
                }

                if (name.length < MIN_LENGTH) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = `Link name must be at least ${MIN_LENGTH} characters.`;
                }

                //Name should not contain special characters
                if (/[^a-zA-Z0-9 $\-&''\u2018\u2019()\.\,\:\;\!\?\u2013\u2014]/.test(name)) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Link name contains unsupported characters.';
                }

                // Source should not contain special characters
                if (/[^a-zA-Z0-9 ]/.test(source)) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = 'Source cannot contain special characters.';
                }

                if (!source) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = 'Source cannot be empty.';
                }

                if (source.length > MAX_SOURCE_LENGTH) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = `Source name cannot exceed ${MAX_SOURCE_LENGTH} characters.`;
                }

                sources.add(source);
                link_names.add(name);
            });

            if (this.additional_links.length === 0) {
                has_error = true;
                this.additional_links[0].has_link_name_error = true;
                this.additional_links[0].link_name_error_text = 'At least one link is required.';
            }

            if (this.link_type === 'episode') {
                if (this.prefix_episode_select.getValue() === '' || this.prefix_episode_select.getValue() === null) {
                    has_error = true;
                    this.no_episode_selected_error = true;
                }
            }

            if (has_error) {
                this.submit_button_disabled = false;
                this.submit_button_text = SUBMIT_BUTTON_TEXT;
                return;
            }

            this.handle_form_submit(event);

        },
        handle_form_submit(event) {
            // Submit the form
            const form = this.$refs.tracking_link_form;
            const formData = new FormData(form);

            if (this.link_type === 'episode') {
                const episodeId = this.prefix_episode_select.getValue();
                formData.append('episode_id', episodeId);
            } else {
                formData.delete('episode_id');
            }

            formData.append('link_type', this.link_type);

            fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // next_url to go to to the next screen
                        window.location.href = data.next_url;
                    } else {
                        alert('Error: ' + data.error);
                        this.submit_button_disabled = false;
                        this.submit_button_text = SUBMIT_BUTTON_TEXT;
                    }
                })
                .catch(error => console.error('Error:', error));
        },

        refresh_steps: [
            ['Accessing feed...', 10],
            ['Getting latest episode data...', parseInt(Math.random() * 8) + 3],
            ['Refresh complete!', 2]],
        fetch_data_button_text: 'Fetch latest episodes',
        refreshing: false,
        refreshing_state(i) {
            let that = this;
            this.refreshing = true;
            if (i < this.refresh_steps.length) {
                this.prefix_episode_select.disable();
                this.fetch_data_button_text = this.refresh_steps[i][0];
                setTimeout(() => {
                    this.refreshing_state(i + 1);
                }, this.refresh_steps[i][1] * 1000);
            } else {
                this.refreshing = false;
                this.prefix_episode_select.enable();
                this.prefix_episode_select.clear();
                this.prefix_episode_select.load((query, callback) => {
                    fetch(that.prefix_episode_load_url + '?search=' + encodeURIComponent(query))
                        .then(response => response.json())
                        .then(data => callback(data))
                        .catch(() => callback([]));
                });
                this.fetch_data_button_text = 'Fetch latest episodes';
            }
        },
        fetch_latest_data() {
            this.refreshing_state(0)
            fetch(this.prefix_latest_episode_url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            }).then(response => response.json())
                .then(data => {

                })
        }

    }));
})

function initFormHandlers(alpineCtx) {
    const selectField = document.getElementById("option-select");
    const customOptionField = document.getElementById("custom-option-field");
    const customOptionInput = document.getElementById("custom-option-input");
    const clearSourceButton = document.getElementById("clear-source");
    const errorText = document.getElementById("error_text");

    const showOrHideCustomField = () => {
        if (selectField.value === "Other") {
            selectField.style.display = "none";
            customOptionField.style.display = "flex";
            customOptionInput.disabled = false;
        }
    };

    selectField.addEventListener("change", showOrHideCustomField);
    showOrHideCustomField();

    clearSourceButton.addEventListener("click", () => {
        selectField.selectedIndex = 0;
        selectField.style.display = "flex";
        customOptionField.style.display = "none";
        customOptionInput.value = "";
        customOptionInput.disabled = true;
        errorText.classList.remove("text-red-500");
        errorText.classList.add("text-gray-500");
        errorText.textContent =
            "Based on your source, this is how the link will show up in your analytics.";
    });

    const form = selectField.closest("form");
    form.addEventListener("submit", function (e) {
        if (selectField.value === "Other" && customOptionInput.value === "") {
            errorText.classList.remove("text-gray-500");
            errorText.classList.add("text-red-500");
            errorText.textContent =
                "Please enter a source or pick one from the list.";
            e.preventDefault();
        }
    });

    customOptionInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    });
}

function tomSelectMixin() {
    return {
        prefix_episode_select: null,
        episode_id: null,

        initTomSelect() {
            this.prefix_episode_select = new TomSelect('#ql_select_episode', {
                maxItems: 1,
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                placeholder: 'Type an episode name',
                load: (query, callback) => {
                    if (!query.length) return callback();

                    fetch(this.prefix_episode_load_url + '?search=' + encodeURIComponent(query), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    })
                        .then(response => response.json())
                        .then(data => callback(data))
                        .catch(() => callback([]));
                },
                create: false
            });
        }
    }
}